module.exports = __webpack_public_path__ + "img/help.bfc3672c.svg";